"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ObjectPreview = void 0;
const PropertyPreview_1 = require("./PropertyPreview");
class ObjectPreview {
    constructor(value, overflow) {
        this.overflow = false;
        this.properties = [];
        if (typeof value !== 'object' || value === null) {
            throw new Error(`ObjectPreview accepts object type only. given ${value}`);
        }
        this.type = 'object';
        this.overflow = overflow;
        if (Array.isArray(value)) {
            this.subtype = 'array';
            this.description = `Array(${value.length})`;
            this.properties = value.map((v, i) => new PropertyPreview_1.PropertyPreview(`${i}`, v));
        }
        else {
            this.description = `Object`;
            this.properties = Object.entries(value).map(([key, v]) => new PropertyPreview_1.PropertyPreview(key, v));
        }
    }
}
exports.ObjectPreview = ObjectPreview;
